import React, { useEffect, useMemo } from "react";
import {
  FormAutocomplete,
  formClasses,
  labelClasses,
  LabeledAutocomplete,
} from "../styles/AutocompleteStyles";
import { handleMUISelectEvent, toStandardCase } from "../utils/UtilFunctions";
import { Keys } from "../utils/Enum.keys";
import { TextField } from "@mui/material";
import { EMPTY_STRING } from "../utils/constants";
import { useLazyQuery } from "@apollo/client";
import { GetItemErrorMsgs } from "../components/modules/asset/masters/items/ItemErrorMsg/queries/queries";
import {
  GetItemErrorMsgsResult,
  GetItemErrorMsgsvar,
} from "../components/modules/asset/masters/items/ItemErrorMsg/queries/types";

import useUrlParams from "../customHooks/useUrlParams";
export enum TicketReasonOptions {
  ACCIDENTS = "ACCIDENTS",
  ENFORCEMENT_CAMERA_NOT_WORKING = "ENFORCEMENT_CAMERA_NOT_WORKING",
  LINK_DOWN = "LINK_DOWN",
  MANUAL_NOT_WORKING = "MANUAL_NOT_WORKING",
  MNG_FAILURE = "MNG_FAILURE",
  POWER_FAILURE = "POWER_FAILURE",
  RED_SIGNAL_LIGHT_NOT_WORKING = "RED_SIGNAL_LIGHT_NOT_WORKING",
  RLVD_NOT_WORKING = "RLVD_NOT_WORKING",
  SIGNAL_LIGHTS_NOT_WORKING = "SIGNAL_LIGHTS_NOT_WORKING",
  SURVELLANCE_CAMERA_NOT_WORKING = "SURVELLANCE_CAMERA_NOT_WORKING",
  TIMING_PHASE_CHANGE = "TIMING/PHASE_CHANGE",
  VA_NOT_WORKING = "VA_NOT_WORKING",
  YELLOW_SIGNAL_NOT_WORKING = "YELLOW_SIGNAL_NOT_WORKING",
  OTHERS = "OTHERS",
}

interface Props {
  value: string;
  onChange: (newValue: string) => void;
  itemId: number;
  itemDetailsId: number;
  label?: string;
  disabled?: boolean;
}
const TicketErrorMsgSelect = ({
  value,
  onChange,
  itemId,
  itemDetailsId,
  label,
  disabled,
}: Props) => {
  const { customer_id } = useUrlParams();

  const [GetErrorMsgs, { data }] = useLazyQuery<
    GetItemErrorMsgsResult,
    GetItemErrorMsgsvar
  >(GetItemErrorMsgs);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (customer_id) {
          GetErrorMsgs({
            variables: {
              customerID: customer_id,
              itemID: itemId,

              itemDetailsID: itemDetailsId,
            },
          });
        }
      } catch (err) {
        console.error((err as Error).message);
      }
    };
    fetchData();
  }, [itemId, itemDetailsId, GetErrorMsgs, customer_id]);

  const options = useMemo(() => {
    if (data && data.GetItemErrorMsgs) {
      return data.GetItemErrorMsgs.map((item) => item.errMsg);
    } else {
      return [];
    }
  }, [data]);

  const commonAutocompleteProps = {
    className: label ? labelClasses.inputRoot : formClasses.inputRoot,
    openOnFocus: true,
    disabled: disabled,
    onChange: (e: React.SyntheticEvent<Element, Event>, value: unknown) =>
      onChange(value as string),
  };

  const commonTextFieldProps = {
    label: label || "",
    fullWidth: true,
    InputLabelProps: { shrink: label ? true : false },
    className: label
      ? labelClasses.formControlRoot
      : formClasses.formControlRoot,
  };

  const Autocomplete = label ? LabeledAutocomplete : FormAutocomplete;

  return (
    <Autocomplete
      {...commonAutocompleteProps}
      value={value}
      options={options}
      // Conditional value
      isOptionEqualToValue={(option) =>
        (option as string) === value || value === EMPTY_STRING
      }
      getOptionLabel={(option) =>
        toStandardCase(option as string).replaceAll("_", " ")
      }
      onKeyDown={(e) => {
        if (e.key === Keys.ENTER) {
          handleMUISelectEvent(e);
        }
      }}
      // autoComplete={false}
      renderInput={(params) => (
        <TextField
          {...params}
          {...commonTextFieldProps}
          autoComplete="one-time-code"
        />
      )}
    />
  );
};

export default TicketErrorMsgSelect;
